// extracted by mini-css-extract-plugin
export default {"root":"SponsorshipLanding_root__-GdgB","unavailableForm":"SponsorshipLanding_unavailableForm__mzOVY"};